import React, {useRef} from 'react';
import emailjs         from '@emailjs/browser';
import {FormattedMessage, FormattedDate} from 'react-intl';
import styled, {css}   from 'styled-components';
import  {Formulario, Label,  Input, ContenedorTextarea, ContenedorBotonCentrado, Boton}  from '../components/ComponentesFormulario';


import "../components/FormularioContacto.css";

import { FontAwesomeIcon }               from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faTimesCircle }         from '@fortawesome/free-solid-svg-icons';

const formularioValido= false;

const FormularioContacto = () => {
	

	    
					const refForm = useRef();
               
					const handleSubmit = (event) => {
						event.preventDefault();
						//console.log(refForm.current);
						const serviceId = "service_9e67dnh";
						const templateId= "template_lskc1cd"
						const apikey="eR1gDCLAZwazOW_oP"
					
						
						emailjs.sendForm (serviceId,templateId,refForm.current,apikey)
						
						.then(result => console.log(result.text),
						refForm.current.reset(),
					    alert("Mensaje enviado correctamente.")
				
						)
						.catch (error => console.log(error));
						
						
					}
					
	
	return (

<div className="principal">
		<Formulario  ref={refForm} action="" onSubmit={handleSubmit}> 
        <div>
		    <Label htmlFor=""> 
			<FormattedMessage 
								id="app.labelnombre"
								defaultMessage="Nombre y Apellido"
								values={
									{
										name: 'labelnombre'
								    }
							    }/>
			
			</Label>
		    <Input 
				 name='username'
				 type="text" 
				 placeholder="" 
				 required
				 />            			 
		 </div>	 
		 <div>
		    <Label htmlFor=""> 
			<FormattedMessage 
								id="app.labelcorreo"
								defaultMessage="Correo Electronico"
								values={
									{
										name: 'labelcorreo'
								    }
							    }/>
			
			</Label>
		    <Input 
			 name='email' 
			 type="email" 
			 placeholder="" 
             required
			 />  
		 </div>	
         <ContenedorTextarea>	
		    <Label htmlFor=""> 
			  <FormattedMessage 
								id="app.labelmensaje"
								defaultMessage="Mensaje"
								values={
									{
										name: 'labelmensaje'
								    }
							    }/>
			</Label>
            <textarea name="mensaje" rows={4} cols={40}  
			 name='mensaje'
			 type="text" 
			 placeholder=""  
			 required 
			 />
        </ContenedorTextarea>
		<ContenedorBotonCentrado>
		  <Boton type ="submit">

		<FormattedMessage 
								id="app.enviar"
								defaultMessage="enviar"
								values={
									{
										name: 'Enviar'
								    }
							    }/>
		</Boton>
		</ContenedorBotonCentrado> 
		</Formulario>
	</div>	
	
	);
}
export default FormularioContacto